var map = {
	"./cs-Czech-mac.json": 43763,
	"./cs-Czech-pc.json": 88717,
	"./da-Danish-mac.json": 26814,
	"./da-Danish-pc.json": 73606,
	"./de-German-mac.json": 78997,
	"./de-German-pc.json": 92763,
	"./de-Swiss_German-mac.json": 30461,
	"./de-Swiss_German-pc.json": 85283,
	"./en-British-mac.json": 75618,
	"./en-British-pc.json": 25018,
	"./en-Colemak-mac.json": 45945,
	"./en-Dvorak-mac.json": 66060,
	"./en-Dvorak-pc.json": 36704,
	"./en-Dvorak_Lefthanded-mac.json": 20476,
	"./en-Dvorak_Lefthanded-pc.json": 7024,
	"./en-Dvorak_Righthanded-mac.json": 47341,
	"./en-Dvorak_Righthanded-pc.json": 49651,
	"./en-US-mac.json": 68683,
	"./en-US-pc.json": 86789,
	"./es-Spanish-mac.json": 70710,
	"./es-Spanish-pc.json": 14686,
	"./fr-Bepo-pc.json": 27194,
	"./fr-Canadian_French-mac.json": 47588,
	"./fr-Canadian_French-pc.json": 1592,
	"./fr-French-mac.json": 95918,
	"./fr-French-pc.json": 40982,
	"./fr-Swiss_French-mac.json": 77910,
	"./fr-Swiss_French-pc.json": 50142,
	"./hu-Hungarian-mac.json": 81912,
	"./hu-Hungarian-pc.json": 99148,
	"./it-Italian-mac.json": 11287,
	"./it-Italian-pc.json": 56065,
	"./nb-Norwegian-mac.json": 69958,
	"./nb-Norwegian-pc.json": 72302,
	"./nl-Dutch-mac.json": 67070,
	"./nl-Dutch-pc.json": 5190,
	"./pl-Polish-mac.json": 81947,
	"./pl-Polish-pc.json": 1781,
	"./pt-Brazilian-mac.json": 73344,
	"./pt-Portuguese-mac.json": 82423,
	"./pt-Portuguese-pc.json": 25377,
	"./ro-Romanian-mac.json": 22952,
	"./ro-Romanian-pc.json": 76220,
	"./sv-Swedish-mac.json": 17070,
	"./sv-Swedish-pc.json": 50102,
	"./tr-Turkish_Q-mac.json": 93436,
	"./tr-Turkish_Q-pc.json": 85936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62782;